import React, { createContext, useState } from 'react'

export const AccountLockedContext = createContext(false)

export const AccountLockedUpdateContext = createContext(() => {})

export default function AccountLockedProvider({ children }) {
  const [accountLocked, setAccountLocked] = useState(true)
  return (
    <AccountLockedContext.Provider value={accountLocked}>
      <AccountLockedUpdateContext.Provider value={setAccountLocked}>{children}</AccountLockedUpdateContext.Provider>
    </AccountLockedContext.Provider>
  )
}
